import React from 'react'

import HomeNavbar from './HomeNavbar'
import ProfileNavbar from './ProfileNavbar'
import NotificationNavbar from './NotificationNavbar'
import SettingNavbar from './SettingNavbar'
import ChangePasswordNavbar from './ChangePasswordNavbar'
import UploadNavbar from './UploadNavbar'
import TransactionHistoryNavbar from './TransactionHistoryNavbar'
import RewardItemNavbar from './RewardItemNavbar'
import EventNavbar from './EventNavbar'
import InstructionDetailNavbar from './InstructionDetailNavbar'
import CartNavbar from './CartNavbar'
import CartDetailNavbar from './CartDetailNavbar'

const Navbar = ({
  client,
  sites,
  activeSite,
  setActiveSite,
  sidebarToggler
}) => {
  return window.location.pathname.split('/')[1] === 'profile' ? (
    <ProfileNavbar />
  ) : window.location.pathname.split('/')[1] === 'notifications' ? (
    <NotificationNavbar />
  ) : window.location.pathname.split('/')[1] === 'setting' ? (
    <SettingNavbar />
  ) : window.location.pathname.split('/')[1] === 'changePassword' ? (
    <ChangePasswordNavbar />
  ) : window.location.pathname.split('/')[1] === 'upload-proof' ? (
    <UploadNavbar />
  ) : window.location.pathname.split('/')[1] === 'rewards' &&
    window.location.pathname.split('/')[2] === 'transaction' ? (
    <TransactionHistoryNavbar />
  ) : window.location.pathname.split('/')[1] === 'rewards' &&
    window.location.pathname.split('/')[2] === 'item' ? (
    <RewardItemNavbar />
  ) : window.location.pathname.split('/')[1] === 'communications' &&
    window.location.pathname.split('/')[2] === 'instructions' ? (
    <InstructionDetailNavbar />
  ) : window.location.pathname.split('/')[1] === 'rewards' &&
    window.location.pathname.split('/')[2] === 'cart' ? (
    <CartNavbar />
  ) : window.location.pathname.split('/')[1] === 'rewards' &&
    window.location.pathname.split('/')[2] === 'carts' ? (
    <CartDetailNavbar />
  ) : (
    <HomeNavbar
      client={client}
      sites={sites}
      activeSite={activeSite}
      setActiveSite={setActiveSite}
      sidebarToggler={sidebarToggler}
    />
  )
}

export default Navbar
